import React from 'react'
import { THEME } from 'utils'

const PageHeader = ({ title, details }) => {
  return (
    <>
      <div className='page_header'>
        <h1>{title}</h1>
        <div className='line' />
        {details && <h2>{details}</h2>}
      </div>
      <style jsx>{`
        .page_header {
          padding: 4%;
          overflow: hidden;
          width: 100%;
          background-color: #f5f5f5;
        }
        .page_header h1 {
          margin: 0;
          font-size: 1rem;
          line-height: 20px;
        }
        .line {
          width: 100%;
          height: 3px;
          background: #eb3e3f;
          margin: 6px 0;
        }
        .page_header h2 {
          margin: 0;
          font-size: 0.75rem;
          color: #eb3e3f;
        }
        @media (min-width: ${THEME.BREAKPOINTS.XS}px) {
          .page_header {
            padding: 3%;
          }
          .page_header h1 {
            font-size: 1.45rem;
            line-height: 30px;
          }
          .page_header h2 {
            margin: 0;
            width: 90%;
            font-size: 0.95rem;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.SM}px) {
          .page_header h1 {
            font-size: 1.3rem;
          }
          .page_header h2 {
            font-size: 0.8rem;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.MD}px) {
          .page_header h1 {
            font-size: 1.7rem;
          }
          .line {
            margin: 10px 0;
          }
          .page_header h2 {
            font-size: 1.05rem;
          }
        }
        @media (min-width: ${THEME.BREAKPOINTS.XL}px) {
          .page_header h1 {
            font-size: 1.75rem;
          }
          .page_header h2 {
            font-size: 1.1rem;
          }
        }
      `}</style>
    </>
  )
}

export default PageHeader
